import { RestResource } from './RestResource';

//export function ResourceCall(options?: any):
